// GraphQL operations for chat

export const getMessages = /* GraphQL */ `
  query GetMessages($leagueId: ID!, $limit: Int, $nextToken: String) {
    getMessages(leagueId: $leagueId, limit: $limit, nextToken: $nextToken) {
      items {
        id
        leagueId
        userId
        userName
        userEmail
        content
        type
        timestamp
        reactions {
          messageId
          userId
          userName
          emoji
          timestamp
        }
      }
      nextToken
    }
  }
`;

export const sendMessage = /* GraphQL */ `
  mutation SendMessage($leagueId: ID!, $content: String!, $type: MessageType, $userName: String) {
    sendMessage(leagueId: $leagueId, content: $content, type: $type, userName: $userName) {
      id
      leagueId
      userId
      userName
      userEmail
      content
      type
      timestamp
      reactions {
        messageId
        userId
        userName
        emoji
        timestamp
      }
    }
  }
`;

export const addReaction = /* GraphQL */ `
  mutation AddReaction($messageId: ID!, $leagueId: ID!, $emoji: String!) {
    addReaction(messageId: $messageId, leagueId: $leagueId, emoji: $emoji) {
      messageId
      userId
      userName
      emoji
      timestamp
    }
  }
`;

export const removeReaction = /* GraphQL */ `
  mutation RemoveReaction($messageId: ID!, $leagueId: ID!, $emoji: String!) {
    removeReaction(messageId: $messageId, leagueId: $leagueId, emoji: $emoji)
  }
`;

export const markAsRead = /* GraphQL */ `
  mutation MarkAsRead($leagueId: ID!) {
    markAsRead(leagueId: $leagueId)
  }
`;

export const getUnreadCount = /* GraphQL */ `
  query GetUnreadCount($leagueId: ID!) {
    getUnreadCount(leagueId: $leagueId)
  }
`;

export const onNewMessage = /* GraphQL */ `
  subscription OnNewMessage($leagueId: ID!) {
    onNewMessage(leagueId: $leagueId) {
      id
      leagueId
      userId
      userName
      userEmail
      content
      type
      timestamp
      reactions {
        messageId
        userId
        userName
        emoji
        timestamp
      }
    }
  }
`;

export const onNewReaction = /* GraphQL */ `
  subscription OnNewReaction($leagueId: ID!) {
    onNewReaction(leagueId: $leagueId) {
      messageId
      userId
      userName
      emoji
      timestamp
    }
  }
`;

// TypeScript types
export interface Message {
  id: string;
  leagueId: string;
  userId: string;
  userName: string;
  userEmail?: string;
  content: string;
  type: 'USER' | 'SYSTEM';
  timestamp: string;
  reactions?: Reaction[];
}

export interface Reaction {
  messageId: string;
  userId: string;
  userName: string;
  emoji: string;
  timestamp: string;
}

export interface MessageConnection {
  items: Message[];
  nextToken?: string;
}
